import * as Action from '../action';

export default (state = [], action) => {
  switch (action.type) {
    case Action.ADD_REEFER_DATA_DETAILS:
      return { ...action.reeferDataDetails };
    default: return state;
  }
};
